import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClipboardComponent} from "../clipboard/clipboard.component";

@Component({
  selector: 'multi-item-hover',
  standalone: true,
  imports: [CommonModule, ClipboardComponent],
  templateUrl: './multi-item-hover.component.html',
  styleUrls: ['./multi-item-hover.component.scss']
})
export class MultiItemHoverComponent {
  @Input() values: string[] = []
  @Input() label: string = "Placeholder Label"
  @Input() data: any= undefined;
}
